class ZapietAPI {
    constructor(apiKey) {
      this.apiKey = apiKey;
      this.baseURL = 'https://api.zapiet.com/v1.0';
      this.headers = {
        'Authorization': `Bearer ${apiKey}`,
        'Content-Type': 'application/json'
      };
    }

    async getDeliveryOptions(zipCode, shop) {
        try {
          // Get cart data formatted for Zapiet API (await the async function)
          const cartData = await getCartForZapiet(shop);
          
          const requestBody = {
            geoSearchQuery: zipCode,
            shop: shop,
            shoppingCart: cartData.shoppingCart
          };
          
          const response = await fetch(`${this.baseURL}/delivery/locations`, {
            method: 'POST',
            headers: this.headers,
            body: JSON.stringify(requestBody)
          });
    
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
    
          const data = await response.json();
          return data;
        } catch (error) {
          console.error('❌ Error getting delivery options:', error);
          throw error;
        }
    }

    /**
     * Get cart item count
     * @returns {Promise<number>} Number of items in cart
     */
    async getCartItemCount() {
        try {
          return await getCartItemCount();
        } catch (error) {
          console.error('❌ Error getting cart item count:', error);
          return 0;
        }
    }

    /**
     * Get full cart data
     * @returns {Promise<object>} Full cart object
     */
    async getCart() {
        try {
          return await getCartItemCount(true);
        } catch (error) {
          console.error('❌ Error getting cart:', error);
          return null;
        }
    }

    /**
     * Get available pickup options from Zapiet API
     * @param {string} shop - Shop domain (e.g., 'florisflower.myshopify.com')
     * @returns {Promise<object>} Pickup options data
     */
    async getPickupOptions(shop) {
        try {
          // Get cart data formatted for Zapiet API
          const cartData = await getCartForZapiet(shop);
          
          const requestBody = {
            shop: shop,
            shoppingCart: cartData.shoppingCart
          };
          
          const response = await fetch(`${this.baseURL}/pickup/locations`, {
            method: 'POST',
            headers: this.headers,
            body: JSON.stringify(requestBody)
          });
    
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
    
          const data = await response.json();
          return data;
        } catch (error) {
          console.error('❌ Error getting pickup options:', error);
          return { error: error.message };
        }
    }
}